import React from "react";
import { Link } from "react-router-dom";
import {
  Col,
  Container,
  ListGroup,
  Row,
} from "react-bootstrap";

const PrivacyPolicy = (props) => {
  return (
    <>
      <Container>
        <Row className="common-styling">
          <Col xs="12" className="mb-4">
            <h1>Privacy Policy</h1>
          </Col>
          <Col xs="12">
            <div className="how-it-works-card">
              <p>
                At stud.com, accessible from www.stud.com, one of our main
                priorities is the privacy of our visitors. This Privacy Policy
                document contains types of information that is collected and
                recorded by www.stud.com and how we use it.
              </p>

              <p>
                If you have additional questions or require more information
                about our Privacy Policy, do not hesitate to contact us.
              </p>

              <p>
                This Privacy Policy applies only to our online activities and is
                valid for visitors to our website with regards to the
                information that they shared and/or collect in www.stud.com.
                This policy is not applicable to any information collected
                offline or via channels other than this website.
              </p>

              <p>
                <strong>Consent</strong>
              </p>

              <p>
                By using our website, you hereby consent to our Privacy Policy
                and agree to its terms.
              </p>

              <p>
                <strong>Information we collect</strong>
              </p>

              <p>
                The personal information that you are asked to provide, and the
                reasons why you are asked to provide it, will be made clear to
                you at the point we ask you to provide your personal
                information.
              </p>

              <p>
                If you contact us directly, we may receive additional
                information about you such as your name, email address, phone
                number, the contents of the message and/or attachments you may
                send us, and any other information you may choose to provide.
              </p>

              <p>
                When you register for an Account, we may ask for your contact
                information, including items such as name, company name,
                address, email address, and telephone number.
              </p>

              <p>
                <strong>How we use your information</strong>
              </p>

              <p>
                We use the information we collect in various ways, including to:
              </p>
              <ListGroup className="my-4">
                <ListGroup.Item>
                  Provide, operate, and maintain our website
                </ListGroup.Item>
                <ListGroup.Item>
                  Improve, personalize, and expand our website
                </ListGroup.Item>
                <ListGroup.Item>
                  Understand and analyze how you use our website
                </ListGroup.Item>
                <ListGroup.Item>
                  Develop new products, services, features, and functionality
                </ListGroup.Item>
                <ListGroup.Item>
                  Communicate with you, either directly or through one of our
                  partners, including for customer service, to provide you with
                  updates and other information relating to the website, and for
                  marketing and promotional purposes
                </ListGroup.Item>
                <ListGroup.Item>Send you emails</ListGroup.Item>
                <ListGroup.Item>Find and prevent fraud</ListGroup.Item>
              </ListGroup>
              <p>
                <strong>Log Files</strong>
              </p>
              <p>
                www.stud.com follows a standard procedure of using log files.
                These files log visitors when they visit websites. All hosting
                companies do this and a part of hosting services' analytics. The
                information collected by log files include internet protocol
                (IP) addresses, browser type, Internet Service Provider (ISP),
                date and time stamp, referring/exit pages, and possibly the
                number of clicks. These are not linked to any information that
                is personally identifiable. The purpose of the information is
                for analyzing trends, administering the site, tracking users'
                movement on the website, and gathering demographic information.
              </p>

              <p>
                <strong>Cookies and Web Beacons</strong>
              </p>

              <p>
                Like any other website, www.stud.com uses 'cookies'. These
                cookies are used to store information including visitors'
                preferences, and the pages on the website that the visitor
                accessed or visited. The information is used to optimize the
                users' experience by customizing our web page content based on
                visitors' browser type and/or other information.
              </p>

              <p>
                <strong>Google DoubleClick DART Cookie</strong>
              </p>

              <p>
                Google is one of a third-party vendor on our site. It also uses
                cookies, known as DART cookies, to serve ads to our site
                visitors based upon their visit to www.website.com and other
                sites on the internet. However, visitors may choose to decline
                the use of DART cookies by visiting the Google ad and content
                network Privacy Policy at the following URL –&nbsp;
                <Link
                  style={{ color: "#ff5301" }}
                  target="_blank"
                  to="https://policies.google.com/technologies/ads"
                >
                  https://policies.google.com/technologies/ads
                </Link>
              </p>
              <p>
                <strong>Limitation of Liability </strong>
              </p>

              <p>
                Contents of this Website The contents of this website were
                created with the highest possible degree of accuracy. However,
                the provider will not be liable for the correctness,
                completeness and up-to-dateness of the contents provided.
                Utilization of the retrievable contents will be at the risk of
                the user. Contributions attributable to specific persons
                represent the opinion of the respective author and do not
                reflect the opinions of the provider.
              </p>

              <p>
                <strong>Website Availability </strong>
              </p>

              <p>
                The provider will endeavour to supply the services in a
                non-interrupted manner, if possible. However, notwithstanding
                all care taken, the possibility of downtimes can't be excluded.
                The provider reserves the right to alter or terminate the offer
                any time.
              </p>

              <p>
                <strong>External Links </strong>
              </p>

              <p>
                This website contains links to third-party websites (external
                links). These websites are the responsibilities of the
                respective operators. During initial connection of the external
                links, the provider examined the third-party contents to make
                sure there are no violations of applicable laws. At that time,
                no violations of applicable laws were present. The provider has
                no influence on the current and future design and contents of
                the linked sites. The insertion of external links does not mean
                that the provider claims the contents relating to the reference
                or link as proprietary. In the absence of clear evidence on
                violations of applicable law, continuous monitoring of possible
                violations of applicable law are not deemed appropriate. If such
                violations become known, however, external links of that kind
                will be removed immediately.
              </p>

              <p>
                <strong>Advertisements </strong>
              </p>

              <p>
                The respective authors will be responsible for the contents of
                advertisements and the respective websites. The presentation of
                the advertisement does not constitute acceptance by the
                provider.
              </p>

              <p>
                <strong>Our Advertising Partners</strong>
              </p>

              <p>
                Some of advertisers on our site may use cookies and web beacons.
                Our advertising partners are listed below. Each of our
                advertising partners has their own Privacy Policy for their
                policies on user data. For easier access, we hyperlinked to
                their Privacy Policies below.
              </p>
              <ListGroup className="my-4">
                <ListGroup.Item>Google</ListGroup.Item>
              </ListGroup>
              <p>
                <Link style={{color: "#ff5301"}} target="_blank" to="https://policies.google.com/technologies/ads">
                  https://policies.google.com/technologies/ads
                </Link>
              </p>

              <p>
                <strong>Advertising Partners Privacy Policies</strong>
              </p>

              <p>
                You may consult this list to find the Privacy Policy for each of
                the advertising partners of www.stud.com.
              </p>

              <p>
                Third-party ad servers or ad networks uses technologies like
                cookies, JavaScript, or Web Beacons that are used in their
                respective advertisements and links that appear on www.stud.com,
                which are sent directly to users' browser. They automatically
                receive your IP address when this occurs. These technologies are
                used to measure the effectiveness of their advertising campaigns
                and/or to personalize the advertising content that you see on
                websites that you visit.
              </p>

              <p>
                Note that www.stud.com has no access to or control over these
                cookies that are used by third-party advertisers.
              </p>

              <p>
                <strong>Third Party Privacy Policies</strong>
              </p>

              <p>
                www.stud.com's Privacy Policy does not apply to other
                advertisers or websites. Thus, we are advising you to consult
                the respective Privacy Policies of these third-party ad servers
                for more detailed information. It may include their practices
                and instructions about how to opt-out of certain options.
              </p>

              <p>
                You can choose to disable cookies through your individual
                browser options. To know more detailed information about cookie
                management with specific web browsers, it can be found at the
                browsers' respective websites.
              </p>

              <p>
                <strong>
                  CCPA Privacy Rights (Do Not Sell My Personal Information)
                </strong>
              </p>

              <p>
                Under the CCPA, among other rights, the consumers have the right
                to:
              </p>

              <p>
                Request that a business that collects a consumer's personal data
                disclose the categories and specific pieces of personal data
                that a business has collected about consumers.
              </p>

              <p>
                Request that a business delete any personal data about the
                consumer that a business has collected.
              </p>

              <p>
                Request that a business that sells a consumer's personal data,
                not sell the consumer's personal data.
              </p>

              <p>
                If you make a request, we have one month to respond to you. If
                you would like to exercise any of these rights, please contact
                us.
              </p>

              <p>
                <strong>GDPR Data Protection Rights</strong>
              </p>

              <p>
                We would like to make sure you are fully aware of all of your
                data protection rights. Every user is entitled to the following:
              </p>

              <p>
                The right to access – You have the right to request copies of
                your personal data. We may charge you a small fee for this
                service.
              </p>

              <p>
                The right to rectification – You have the right to request that
                we correct any information you believe is inaccurate. You also
                have the right to request that we complete the information you
                believe is incomplete.
              </p>

              <p>
                The right to erasure – You have the right to request that we
                erase your personal data, under certain conditions.
              </p>

              <p>
                The right to restrict processing – You have the right to request
                that we restrict the processing of your personal data, under
                certain conditions.
              </p>

              <p>
                The right to object to processing – You have the right to object
                to our processing of your personal data, under certain
                conditions.
              </p>

              <p>
                The right to data portability – You have the right to request
                that we transfer the data that we have collected to another
                organization, or directly to you, under certain conditions.
              </p>

              <p>
                If you make a request, we have one month to respond to you. If
                you would like to exercise any of these rights, please contact
                us.
              </p>

              <p>
                <strong>Children's Information</strong>
              </p>

              <p>
                Another part of our priority is adding protection for children
                while using the internet. We encourage parents and guardians to
                observe, participate in, and/or monitor and guide their online
                activity.
              </p>

              <p>
                www.stud.com does not knowingly collect any Personal
                Identifiable Information from children under the age of 16. If
                you think that your child provided this kind of information on
                our website, we strongly encourage you to contact us immediately
                and we will do our best efforts to promptly remove such
                information from our records.
              </p>
            </div>
          </Col>
        </Row>
      </Container>
    </>
  );
};
export default PrivacyPolicy;
